import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, XerxesClientConfig } from '@sky/xerxes-client-react';
import Application from './App';
import {COGNITO} from './config';
import 'bootstrap/dist/css/bootstrap.min.css';

// Xerxes Config
const xerxesClientConfig: XerxesClientConfig = {
  flow: COGNITO.flow,
  clientId: COGNITO.clientId,
  scopes: COGNITO.scopes,
  signInRedirectUrl: COGNITO.signInRedirectUrl,
  signOutRedirectUrl: COGNITO.signOutRedirectUrl,
  provider: {
    type: 'COGNITO',
    baseUrl: COGNITO.baseUrl,
  }
};

// Global Auth Error Handler
const onAuthError = (error: any) => {
  console.error('Global Auth Error Handler ::', error);
}

// Render the Application
const root = ReactDOM.createRoot(document.getElementById('application') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider config={xerxesClientConfig} onError={onAuthError}>
        <Application />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
